import {
  useGetUserVideoAvatars,
  useDeleteVideoAvatar,
  likeVideoAvatar,
  unlikeVideoAvatar,
  getGetUserVideoAvatarsQueryKey,
  useGetTopVideoAvatars,
  getGetTopVideoAvatarsQueryKey,
} from "@packages/api/madlenAPI";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import HeygenVideoCard from "../../components/heygen-video-generator/HeygenVideoCard";

const HeygenVideoDetailComponent = ({ tool }: { tool: any }) => {
  return <HeygenVideoCard avatar={tool} />;
};

const HeygenVideoView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserVideoAvatars}
      useDeleteTool={useDeleteVideoAvatar}
      getGetToolsQueryKey={getGetUserVideoAvatarsQueryKey}
      useGetTopTools={useGetTopVideoAvatars}
      likeTool={likeVideoAvatar}
      unlikeTool={unlikeVideoAvatar}
      getGetTopToolsQueryKey={getGetTopVideoAvatarsQueryKey}
      toolType="heygenVideoGenerator"
      toolPath="video-avatar-generator"
      DetailComponent={HeygenVideoDetailComponent}
      colors={{
        light: "from-purple-500 to-violet-600",
        dark: "dark:from-purple-400 dark:to-violet-500",
        iconBg: "bg-purple-100 dark:bg-purple-900/50",
        iconColor: "text-purple-600 dark:text-purple-400",
        hover: "hover:bg-purple-50 dark:hover:bg-purple-900/20",
      }}
      toolColor="purple"
      gradientColor="violet"
      customRefetchInterval={(query) => {
        const firstItem = query.state.data?.data?.[0];
        if (
          firstItem &&
          (!firstItem?.imageUrl ||
            !firstItem?.videoUrl ||
            firstItem.status === "PROCESSING" ||
            !firstItem.transcript)
        ) {
          return 5000;
        }
        return false;
      }}
    />
  );
};

export default HeygenVideoView;
